// extracted by mini-css-extract-plugin
module.exports = {"buttonReset":"IconButton_buttonReset__5kVO0","disabled":"IconButton_disabled__1tnc7"};